module.exports = "fonts/Ekster-Regular.otf";